import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bodyFont", "root"]

  setBodyFont() {
    const selectedOption = this.bodyFontTarget.selectedOptions[0] // <option value="roboto" data-font-name="Syne">Syne</option>

    const bodyFont = selectedOption.dataset.fontName

    this.rootTarget.style.setProperty("--font-family-base", bodyFont)
  }
}
